import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PageHead } from "../GtaxShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/gtax`;

export default function GtaxContact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, f);
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || "Please check your details and try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="gtax-contact-page">
      <PageHead eyebrow="Contact" title="Speak with the Association." sub="Membership enquiries, introductions, member services and compliance matters. Every message is read by a member of our team and answered personally, usually within one business day." />
      <section className="pb-16">
        <div className="gx-wrap grid md:grid-cols-3 gap-6">
          {[["Membership enquiries", "Questions about tiers, the agreement or how the mandate works. Please note that membership is by invitation from an existing member."],
            ["Member services", "Statements, deposits, redemptions and changes to your registered details. Please include your GTX reference so we can locate your record."],
            ["Compliance", "Identity verification, source-of-funds requests, data-protection requests and any concern you wish to raise in confidence."]].map(([h, p]) => (
            <div key={h} className="gx-card p-8" data-testid={`gtax-contact-topic-${h.split(" ")[0].toLowerCase()}`}><h3 className="gx-caps text-lg">{h}</h3><p className="mt-3 text-[color:var(--mute)] leading-relaxed">{p}</p></div>
          ))}
        </div>
      </section>
      <section className="pb-28">
        <div className="gx-wrap grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5 space-y-8">
            <div className="gx-photo h-72"><img src="/gtax/bar.jpg" alt="Gold bar" /></div>
            <div><div className="gx-eyebrow">Office</div><div className="gx-serif text-2xl mt-2">DFI Holdings · Abu Dhabi, UAE</div></div>
            <div><div className="gx-eyebrow">Email</div><a href="mailto:support@gta-x.io" className="gx-serif text-2xl mt-2 block hover:text-[color:var(--gold2)]" data-testid="gtax-contact-email">support@gta-x.io</a></div>
            <div><div className="gx-eyebrow">Hours</div><div className="gx-serif text-2xl mt-2">Monday – Friday · 09:00 – 18:00 GST</div></div>
            <p className="text-sm text-[color:var(--mute)] leading-relaxed border-t border-[color:var(--line)] pt-6" data-testid="gtax-contact-safety">For your security: GTA X will never ask you for wallet seed phrases or passwords, and will never ask you to send funds to an address other than the treasury address shown privately in your member area or in the official @GTA_X_OFFICIAL_BOT. If in doubt, write to support@gta-x.io before sending anything.</p>
          </div>
          {sent ? (
            <div className="lg:col-span-7 gx-card p-12" data-testid="gtax-contact-success">
              <h2 className="gx-serif text-4xl">Thank you.</h2>
              <p className="mt-4 text-[color:var(--mute)]">Your message has been received. We will be in touch shortly.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="lg:col-span-7 gx-card p-10 space-y-8" data-testid="gtax-contact-form">
              {[["name", "Full name", "text"], ["email", "Email", "email"], ["subject", "Subject", "text"]].map(([k, l, t]) => (
                <div key={k}>
                  <label className="block text-xs tracking-widest uppercase text-[color:var(--mute)]">{l}</label>
                  <input type={t} required={k !== "subject"} value={f[k]} onChange={set(k)} className="w-full py-3 text-lg" data-testid={`gtax-contact-${k}`} />
                </div>
              ))}
              <div>
                <label className="block text-xs tracking-widest uppercase text-[color:var(--mute)]">Message</label>
                <textarea required rows={5} value={f.message} onChange={set("message")} className="w-full p-4 mt-3 text-lg" data-testid="gtax-contact-message" />
              </div>
              <button disabled={busy} className="gx-btn disabled:opacity-60" data-testid="gtax-contact-submit">{busy ? "Sending…" : "Send message"}</button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
